import * as React from 'react';

interface Props {
  name: string;
  value: number | string;
}

const FieldInfoItem = ({ name, value }: Props) => {

  return (
    <div className='d-flex'>
      <span className='field-item_name'>{name}</span>
      <span className='field-item_value'>{value}</span>
    </div>
  );
};

export default React.memo(FieldInfoItem);
